module.exports = "../../../../platform/assets/pageMainIcon/ig-business-processing-5.svg";